export const Logo = () => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
    <span className="grid h-10 w-10 place-items-center overflow-hidden rounded-lg bg-white p-0.5">
      <img src="/logo-icon.png" alt="Indian Small Capital" className="h-full w-full object-contain" />
    </span>
    <span className="leading-tight">
      <span className="block font-display text-lg font-extrabold tracking-tight text-white">Indian <span className="text-emerald-400">Small Capital</span></span>
      <span className="block font-mono text-[9px] uppercase tracking-[0.3em] text-slate-500">Microfinance</span>
    </span>
  </span>
);
